import { FC } from 'react';
import { Calendar as ReactCalendar, CalendarProps } from 'react-calendar';

import { StyledArrowIcon, StyledCalendarContainer, StyledRangeCalendarContainer } from './Calendar.styles';
import 'react-calendar/dist/Calendar.css';

const Calendar: FC<CalendarProps> = (props) => {
  const StyledContainer = props.selectRange ? StyledRangeCalendarContainer : StyledCalendarContainer;

  return (
    <StyledContainer data-testid="calendar">
      <ReactCalendar
        {...props}
        className={`hlx-calendar ${props.selectRange ? 'hlx-calendar-range' : ''}`}
        next2Label={null}
        prev2Label={null}
        prevLabel={<StyledArrowIcon />}
        nextLabel={<StyledArrowIcon variant="right" />}
        calendarType="US"
      />
    </StyledContainer>
  );
};

export default Calendar;
